import "./ImportBed.scss";
import ImportBed from "./ImportBed";

export default ImportBed;